import { parseDateValue } from '@/utils/formatDate'

export function sortEstudiosByDateDesc(estudios) {
  return [...(estudios ?? [])].sort((a, b) => {
    const dateA = parseDateValue(a?.date)
    const dateB = parseDateValue(b?.date)
    return (Number.isNaN(dateB) ? 0 : dateB) - (Number.isNaN(dateA) ? 0 : dateA)
  })
}
